import React, {Component} from "react";
import {Input} from "semantic-ui-react";

export class EditableField extends Component {
    constructor(props){
        super(props);
        this.state = {
            editingMode: false,
            content: props.content,
        }
        this.changeInputTimeout = undefined;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
      /**
       * Set the wrapper ref
       */
    setWrapperRef = (node) => {
        this.wrapperRef = node;
    }
    
      /**
       *  If we click outside of the input, that means that we accept our modification, parent callback 'OnChange' is called if the value has changed.
       */
    handleClickOutside = (event) => {
        if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.cancelEdit();
            if(this.props.onChange && (this.state.content !== this.props.content)) {
                this.props.onChange(this.state.content)
            }
        }
    }

    editRow = () => {
        this.setState({
            editingMode : true
        })
    }

    cancelEdit = () => {
        this.setState({
            editingMode: false
        })
    }

    /**
     * Defines Width and Height at 100% (full row) when there is no content, to allow user to click on the row to edit the field.
     * If there's a content, then we restrict the hitbox to the content size (only clicking on the text content will enable editing mode)
     */
    computeClickHitbox = (inlined) => {
        const {content} = this.state;
        let style = {};
        if(content){
            style.width = "fit-content";
        } else {
            style.width = '100%';
            style.height= '100%';
        }
        if(inlined) {
            style.display = 'inline-block'
        }
        return style;
    }

    handleInputChange = (e, val) => {
        let newValue = val.value;
        this.setState({
            content: newValue
        })
    }

    render() {
        const {inlined} = this.props;
        let {editingMode, content} = this.state;
        // We're not in editing mode, so we just return a clickable div
        if(!editingMode) {
            return <div onClick={this.editRow} style={this.computeClickHitbox(inlined)}>{content}</div>
        }

        // Here we are in edit mode, the div now contains an input inside of it
        return <div ref={this.setWrapperRef} style={{display: inlined? 'inline-block' : 'block'}} className="input-wrapper">
            <Input 
            style={{width: '100%'}}
            value={content}
            onChange={this.handleInputChange}
            onBlur={this.cancelEdit}
            />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/EditableField.jsx